/**
 * Price rendering: Product Detail Pages.
 * Uses variant metafields from snippets/price.liquid (data-price-*).
 */
if (!window.Maximize?.loadedScript?.includes("price-rendering-pdp.js")) {
  if (window.Maximize?.loadedScript) {
    window.Maximize.loadedScript.push("price-rendering-pdp.js");
  }

  (function () {
    if (!window.Maximize || window.Maximize.isProductPage !== true) return;

    const LOCATION_READY = "maximize:catalog:ready";
    const VARIANT_UPDATED_PREFIX =
      (typeof PRODUCT_EVENT !== "undefined" && PRODUCT_EVENT.updatedVariant) ||
      "maximize:variant-picker:updated:";

    function money(dollarsString) {
      if (dollarsString == null) return null;
      const amount = Number(String(dollarsString).trim());
      if (!Number.isFinite(amount)) return null;
      const cents = Math.round(amount * 100);
      const fmt = window.Maximize.moneyFormat;
      if (typeof formatMoney === "function" && fmt) {
        try {
          return formatMoney(cents, fmt);
        } catch (_) {
          /* fall through */
        }
      }
      return amount.toFixed(2);
    }

    function activeLocationKey() {
      let name = "";
      try {
        if (window.Alpine && Alpine.store("xStoreMap")?.currentStoreSelected) {
          name = Alpine.store("xStoreMap").currentStoreSelected;
        }
      } catch (_) {
        /* ignore */
      }
      if (!name) {
        try {
          const s = JSON.parse(localStorage.getItem("currentStoreSelected") || "null");
          name = (s && s.selectedStore) || "";
        } catch (_) {
          /* ignore */
        }
      }
      const v = String(name).toLowerCase();
      if (v.indexOf("mississauga") >= 0) return "mississauga";
      if (v.indexOf("windsor") >= 0) return "windsor";
      if (v.indexOf("halifax") >= 0) return "halifax";
      return null;
    }

    function priceFromMetafields(container) {
      const loc = activeLocationKey();
      if (!loc) return null;
      const raw = container.getAttribute("data-price-" + loc);
      if (raw == null || raw === "") return null;
      const amount = Number(raw);
      if (!Number.isFinite(amount) || amount <= 0) return null;
      return { price: raw };
    }

    const MAIN_SCOPE =
      "product-info, .section-main-product, .section-product-details";

    function renderInto(container, priceData) {
      const formattedPrice = money(priceData.price);
      if (formattedPrice == null) return;
      container
        .querySelectorAll(".price:not(.compare-at-price), .main-price")
        .forEach((el) => {
          el.textContent = formattedPrice;
        });
      const compareEl = container.querySelector(".compare-at-price");
      if (compareEl) compareEl.classList.add("hidden");
      container.setAttribute("data-catalog-priced", "true");
    }

    function apply() {
      const scopes = document.querySelectorAll(MAIN_SCOPE);
      const containers = scopes.length
        ? [...scopes].flatMap((s) => [...s.querySelectorAll(".price__container")])
        : [...document.querySelectorAll(".price__container")];
      containers.forEach((container) => {
        const priceData = priceFromMetafields(container);
        if (!priceData) return;
        renderInto(container, priceData);
      });
    }

    document.addEventListener(LOCATION_READY, () => apply());
    document.addEventListener("maximize:store-changed", () => apply());

    function wireVariantEvents() {
      document
        .querySelectorAll("product-info[data-section-id], [data-section-id]")
        .forEach((el) => {
          const sid = el.dataset.sectionId;
          if (!sid) return;
          const evt = VARIANT_UPDATED_PREFIX + sid;
          if (el.__albpe35Wired === evt) return;
          el.__albpe35Wired = evt;
          // Section Rendering API refreshes price metafield attrs for the new variant.
          document.addEventListener(evt, () => apply());
        });
    }

    function init() {
      wireVariantEvents();
      apply();
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
    document.addEventListener(LOCATION_READY, wireVariantEvents);
  })();
}
